import React, { useState } from 'react'
import {
  Typography,
  Link
} from '@material-ui/core';
import UnderLinks from '../UnderLinks/UnderLinks'
import './HeaderLink.scss'
import { Link as RouterLink } from 'react-router-dom';
import { Link as PrismicLink, RichText, Date } from 'prismic-reactjs';



export default function HeaderLink(props) {
  const {
    headerLink,
    scroll,
    timer,
    setTimer,
    setLinks,
    prismicCtx,
    homePage
  } = props

  const [open, setOpen] = useState(false)

  function handleLinkEnter() {
    setOpen(true)
    setLinks(headerLink.items)
  }

  function handleMouseLeave() {
    setOpen(false)
  }

  let myClass

  if (homePage) {
    myClass = scroll ? 'headerLink__nav-link-scroll' : 'headerLink__textShadow'
  } else {
    myClass = 'headerLink__nav-link-scroll'
  }


  return (
    <div onMouseEnter={handleLinkEnter} onMouseLeave={handleMouseLeave}
      style={{ height: '100%' }}>
      <div style={{ height: '100%', display: 'flex', alignItems: 'center', marginTop: 0 }}>
        <RouterLink
          to={prismicCtx.linkResolver(headerLink.primary.linkur)}
          className={`headerLink__nav-link headerLink__nav-link-ltr ${myClass}`}
        // to={prismicCtx.linkResolver(headerLink.link)}
        >
          {headerLink.primary.titill[0].text}
        </RouterLink>
      </div>

      <div style={{ position: 'relative', zIndex: 100 }}>
        <UnderLinks
          links={headerLink.items}
          open={open}
          prismicCtx={prismicCtx}
        />
      </div>


    </div>
  )
} 